import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { Article } from '@/stores/types/landing';

export interface LandingState {
  articles: Article[];
}

export const getDefaultState = (): LandingState => ({
  articles: [],
});

export const useLandingStore = defineStore('landing', () => {
  const articles = ref<Article[]>(getDefaultState().articles);

  const setArticles = (articleData: Article[]): void => {
    articles.value = articleData;
  };

  return {
    articles,
    setArticles,
  };
});
